import React from 'react';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import { useReportsContext } from 'partial/wrappers/ReportsContext';
import { formatNumber } from 'helper';

const labelClassName = 'whitespace-nowrap';
const contentClassName = 'whitespace-nowrap';

const format = [
  { label: 'AGENCY NAME', key: 'organization_name' },
  {
    id: 'balance',
    label: 'BALANCE',
    key: ({ balance }) => <span>{formatNumber(balance, 0)}</span>,
  },
].map((item) => ({
  ...item,
  labelClassName,
  contentClassName,
}));

export default function SubscriberBalance() {
  const { isLoading, list, meta, setPage } = useReportsContext();

  return (
    <div className="flex flex-col gap-10 min-h-[65vh]">
      <Table isLoading={isLoading} data={list} format={format} />
      {!isLoading && <Pagination value={meta} onChange={setPage} />}
    </div>
  );
}
